import React, { useEffect, useState } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import CreateSalesOrder from "./CreateSalesOrder";
import MainTable from "./MainTable";
import ShippingManagement from "../shippment/ShippingManagement"; // ✅ add
import { getSalesOrderById } from "../../services/salesOrder/salesOrder"; // (if needed)
import { toast } from '../../components/AppToast';
import { useTranslation } from "react-i18next";
const SalesOrder = () => {
      const { t, i18n } = useTranslation();
    // whether the form modal/area is open (create/edit/view)
    const [showCreateSO, setShowCreateSO] = useState(false);

    // whether the page-level "Create New SO/STO" button is visible
    const [createVisible, setCreateVisible] = useState(true);


    const [openShipmentRecord, setOpenShipmentRecord] = useState(null);
    const [showShipmentPanel, setShowShipmentPanel] = useState(false);

    const [tableData, setTableData] = useState([]);
    const [version, setVersion] = useState(0);

    // the currently selected row/raw data for edit/view
    const [editRow, setEditRow] = useState(null);

    // mode: 'create' | 'edit' | 'view'
    const [formMode, setFormMode] = useState("create");

    // 🔗 when user clicks a shipment number from table
    const [openShipment, setOpenShipment] = useState(null); // string: shipmentNumber

    const handleNewClick = () => {
        setFormMode("create");
        setEditRow(null);
        setShowCreateSO(true);
        setCreateVisible(true);
    };

    const handleCancel = () => {
        setShowCreateSO(false);
        setEditRow(null);
        setFormMode("create");
        setCreateVisible(true);
    };

    const handleSaved = () => {
        setShowCreateSO(false);
        setEditRow(null);
        setFormMode("create");
        setCreateVisible(true);
        setVersion((v) => v + 1);
    };

    const handleEditOLD = (row) => {
        console.log("handleEdit called with row:", row);
        setFormMode("edit");
        setEditRow(row?._raw ?? row);
        setShowCreateSO(true);
        setCreateVisible(true);
    };

    // When MainTable asks to show a row in read-only view
    const handleViewOLD = (row, opts = {}) => {
        console.log("handleView called with row:", row);
        setFormMode("view");
        setEditRow(row?._raw ?? row);
        setShowCreateSO(true);
        if (opts.hideCreate === true) setCreateVisible(false);
    };


    const handleView = async (row, opts = {}) => {
        // console.log("handleView called with row:", row);
        setFormMode("view");
        setShowCreateSO(true);
        if (opts.hideCreate === true) setCreateVisible(false);

        const id = row?._id ?? row?.id; // defensive: try both
        if (!id) {
            console.warn("handleView: no id found on row, using row as-is");
            setEditRow(row?._raw ?? row);
            return;
        }
        try {
            const soData = await getSalesOrderById(id);
            if (!soData) {
                console.warn(`No sales order returned for id=${id}, using provided row`);
                setEditRow(row?._raw ?? row);
                return;
            }
            setEditRow(soData);
        } catch (err) {
            console.error("Error fetching sales order in handleView:", err);
    
            setEditRow(row?._raw ?? row);

            // show user friendly message if toast is available
            try {
                toast.error(err?.message || "Failed to load sales order details");
            } catch (e) {
                // toast might not be available in this file — ignore
            }
        }
    };



    const handleEdit = async (row) => {
        console.log("handleEdit called with row:", row);

        setFormMode("edit");
        setShowCreateSO(true);
        setCreateVisible(true);

        const id = row?._id ?? row?.id; // safe fallback
        if (!id) {
            console.warn("handleEdit: no id found on row, using raw row");
            setEditRow(row?._raw ?? row);
            return;
        }

        try {
            // API request
            const soData = await getSalesOrderById(id);

            if (!soData) {
                console.warn(`No sales order found for edit, id=${id}`);
                setEditRow(row?._raw ?? row);
                return;
            }

            // put full API data into form
            setEditRow(soData);

        } catch (err) {
            console.error("Error fetching sales order in handleEdit:", err);

            // fallback to incoming row so edit screen still opens
            setEditRow(row?._raw ?? row);

            try {
                toast.error(err?.message || "Failed to load sales order details");
            } catch { }
        }
    };


    // Exposed to MainTable so it can request hide/show of Create button (fallback dialog case)
    const handleToggleCreateVisibility = (visible) => {
        setCreateVisible(Boolean(visible));
    };

    // (optional) your fetchHandler if needed
    const fetchHandler = async () => {
        // ...your existing logic (kept as-is)
    };

    useEffect(() => {
        fetchHandler();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const handleOpenShipmentFromTable = (shipmentNo /*, row */) => {
        const number = String(shipmentNo ?? "").trim();
        console.log("handleOpenShipmentFromTable called with", shipmentNo, "parsed as", number);
        if (!number) return;
        // only keep the shipment number — ShippingManagement will fetch full data itself
        setOpenShipment({ number });
    };


    return (
        <div className="card shadow-lg main-card" style={{ position: "relative" }}>
            <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
                <h4 className="mb-0 h6 fw-semibold">
                    {openShipment
                        ? "Shipment Details"
                        : showCreateSO
                            ? formMode === "view"
                                ? "View SO"
                                : formMode === "edit"
                                    ? "Edit SO"
                                    : "Create SO"
                            : t(`salesOrder.table.soHeader`) }
                </h4>
            </div>

            {/* Breadcrumbs */}
            {(showCreateSO || openShipment) && (
                <nav
                    aria-label="breadcrumb"
                    className="px-3 py-2 border-bottom bg-light mb-2"
                >
                    <ol
                        className="breadcrumb mb-0 align-items-center"
                        style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
                    >
                        <li className="breadcrumb-item">
                            <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none text-muted"
                                onClick={() => {
                                    // back to list
                                    setOpenShipment(null);
                                    setShowCreateSO(false);
                                    setEditRow(null);
                                    setFormMode("create");
                                    setCreateVisible(true);
                                }}
                            >
                                SO
                            </button>
                        </li>
                        <li
                            className="breadcrumb-item active fw-semibold text-primary"
                            aria-current="page"
                        >
                            {openShipment
                                ? "View Shipment"
                                : formMode === "create"
                                    ? "Create SO"
                                    : formMode === "edit"
                                        ? "Edit SO"
                                        : formMode === "view"
                                            ? "View SO"
                                            : "SO Details"}
                        </li>
                    </ol>
                </nav>
            )}

            <div className="card-body">
                <StyledEngineProvider injectFirst>
                    {openShipment ? (
                        // 🔗 Shipment Management page when a shipment number is clicked
                        <ShippingManagement
                            initialValues={{ shipmentNumber: openShipment.number ?? null }}
                            onCancel={() => setOpenShipment(null)}
                            onSubmit={(r) => setOpenShipment(null)}
                        />
                    ) : !showCreateSO ? (
                        <MainTable
                            key={version}
                            onEditRow={handleEdit}
                            onEdit={handleEdit}
                            onViewRow={handleView}
                            onToggleCreateVisibility={handleToggleCreateVisibility}
                            // Page "Create" button
                            showCreateButton={true}
                            createButtonText="Create New SO"
                            createButtonIcon="bi-plus-circle"
                            onCreateClick={handleNewClick}
                            // 🔗 shipment link callback
                            // onOpenShipment={(shipmentNo) => setOpenShipment(shipmentNo)}
                                onOpenShipment={handleOpenShipmentFromTable}
                        />
                    ) : (
                        <CreateSalesOrder
                            initialData={editRow}
                            cancelText="Cancel"
                            onCancel={handleCancel}
                            onSaved={handleSaved}
                            editData={editRow}
                            readOnly={formMode === "view"}
                        />
                    )}
                </StyledEngineProvider>
            </div>
        </div>
    );
};

export default SalesOrder;
